import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseInMemoryCachedRepository } from '@lib/domain-common';
export var QUESTION_RELEASE_IN_MEMORY_CACHED = 'QUESTION_RELEASE_IN_MEMORY_CACHED';

var buildQuestionReleaseCacheKey = function buildQuestionReleaseCacheKey(query) {
  var _query$hasCorrectAnsw, _query$showExplanatio;

  return "".concat(query.formReleaseId, ":").concat((_query$hasCorrectAnsw = query.hasCorrectAnswer) !== null && _query$hasCorrectAnsw !== void 0 ? _query$hasCorrectAnsw : false, ":").concat((_query$showExplanatio = query.showExplanation) !== null && _query$showExplanatio !== void 0 ? _query$showExplanatio : false);
};

export var QuestionReleaseInMemoryCached = /*#__PURE__*/function (_BaseInMemoryCachedRe) {
  _inherits(QuestionReleaseInMemoryCached, _BaseInMemoryCachedRe);

  var _super = _createSuper(QuestionReleaseInMemoryCached);

  function QuestionReleaseInMemoryCached() {
    var _this;

    _classCallCheck(this, QuestionReleaseInMemoryCached);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "cache", new Map());

    return _this;
  }

  _createClass(QuestionReleaseInMemoryCached, [{
    key: "findByQuery",
    value: function findByQuery(query) {
      return this.cache.get(buildQuestionReleaseCacheKey(query));
    }
  }, {
    key: "saveByQuery",
    value: function saveByQuery(query, questions) {
      this.cache.set(buildQuestionReleaseCacheKey(query), questions);
    }
  }, {
    key: "removeAll",
    value: function () {
      var _removeAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.cache.clear();
                return _context.abrupt("return", _get(_getPrototypeOf(QuestionReleaseInMemoryCached.prototype), "removeAll", this).call(this));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function removeAll() {
        return _removeAll.apply(this, arguments);
      }

      return removeAll;
    }()
  }]);

  return QuestionReleaseInMemoryCached;
}(BaseInMemoryCachedRepository);